export default __webpack_public_path__ + "static/media/risk_management_questionnaires_icon.390051e6.svg";